import React from "react";

const StudentTypeButton = ({
  setStudentType,
  formik,
  setParentSubjectRedoLength,
  setparentSubjectProgLength,
  setFoundProgress,
  setDisableProgress,
  setDisableReReg,
  setparentSubjectReSubLength,
  setParentSubjectProgressLength,
  setFoundReReg,
  labelReReg,
  labelArticulate,
  disabled
}) => {
  const student_type_options = [
    { id: 0, label: labelReReg ? labelReReg : "Re-register for failed modules", iconClassName: 'fa-light fa-repeat-1' },
    { id: 1, label: labelArticulate ? labelArticulate :  "Articulate to a new qualification or year", iconClassName: 'fa-light fa-sparkles' },
  ];

  const handleStudentTypeChange = (e) => {
    const value = e.target.value;
    setStudentType && setStudentType(value);
    formik.setFieldValue('student_type', value);
    setParentSubjectRedoLength && setParentSubjectRedoLength([{ subject: "" }]);
    setparentSubjectProgLength && setparentSubjectProgLength([{ subject: "" }]);
    setFoundProgress && setFoundProgress([{ subject: "" }]);
    setparentSubjectReSubLength && setparentSubjectReSubLength([{ subject: "" }])
    setParentSubjectProgressLength && setParentSubjectProgressLength([{ subject: "" }])
    setFoundReReg && setFoundReReg([{ subject: "" }])
    
    setDisableProgress && setDisableProgress(false);
    setDisableReReg && setDisableReReg(false);
  };

  return (
    <div className="form-group col-sm-12 inputfield">
      <h5 className="textdanger heading-5"> I want to:</h5>
      <br />
      <div className="col-sm-12">
        <div className="row">
          {student_type_options.map((opt) => (
            <button
              key={opt.id}
              type="button"
              className={`btn m-1 ${formik.values.student_type === opt.id ? 'btn-primary rereg' : 'btn-white-bordered rereg'}`}
              onClick={() => handleStudentTypeChange({ target: { value: opt.id } })}
              disabled={disabled && formik.values.student_type != opt.id}
            >
            
              {opt.iconClassName && <i className={opt.iconClassName}></i>} {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StudentTypeButton;
